'use client';

import { Breadcrumbs, Link, SxProps, Typography, useTheme } from '@mui/material';

import { ResourceCategory } from '@/types';

interface ResourceCenterBreadcrumbsProps {
  resourceCategory: ResourceCategory;
  hasArticle?: boolean;
  sx?: SxProps;
}

export function ResourceCenterBreadcrumbs({
  hasArticle = false,
  resourceCategory,
  sx = {},
}: ResourceCenterBreadcrumbsProps) {
  const theme = useTheme();
  return (
    <Breadcrumbs
      data-component="ResourceCenterBreadcrumbs"
      aria-label="breadcrumb"
      sx={{
        color: theme.palette.common.black,
        ...sx,
      }}
    >
      <Link underline="hover" color="inherit" href="/resources">
        Resources
      </Link>
      {hasArticle ? (
        <Link underline="hover" color="inherit" href={`/resources/${resourceCategory.Slug}`}>
          {resourceCategory.CategoryName}
        </Link>
      ) : (
        <Typography>{resourceCategory.CategoryName}</Typography>
      )}
    </Breadcrumbs>
  );
}
